export default __webpack_public_path__ + "static/media/chevron-left.663a9eeb.svg";